import React from 'react'
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { BrowserRouter as Router, Switch, Route, useLocation } from "react-router-dom";
import Citas from './citas/main.citas'
import Dash from './patients/dash.patients.main';
import Doctors from './doctors/main.doctors'
import Sucursal from './sucursal'
import PerfilAdministrador from './perfil/perfil.administrador'
import Ingresos from './ingresos/ingresos'
import icon from '../assets/Icon.png';
import Escalas from '../escalas/escalasMenu';
import { Footer, logout, usuario } from '../resources'
import Cortes from './cortes/main.cortes';
import Receptionists from './receptionists/main.receptionists';
import Enfermeros from './enfermeros/main.enfermeros';
import Home from './home/home'
import { CalendarOutlined, DollarCircleOutlined, HomeOutlined, LogoutOutlined, TeamOutlined, UserOutlined } from '@ant-design/icons';
import EscalasEMT from '../doctorViews/expedientes/visitas-details/escalas-emt';
import HojaRegistroEMT from '../doctorViews/expedientes/visitas-details/hoja-registro-emt';

const STAFF_PATHS = ['/doctores', '/recepcionistas', '/enfermeros'];
const FINANCE_PATHS = ['/balances', '/cortes'];

function Navigator() {
  const { pathname } = useLocation();

  return (
    <Navbar bg="primary" variant="dark" expand="lg" sticky="top">
      <Container>
        <Navbar.Brand href="/" style={{ fontFamily: 'Poppins' }}>
          <img src={icon} width="40" height="35" className="d-inline-block align-top" alt="Recreamed logo" style={{ marginRight: 8 }} />
          Re-Crea Med
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="main-navbar" />
        <Navbar.Collapse id="main-navbar">
          <Nav className="me-auto" activeKey={pathname}>
            <Nav.Link href="/" eventKey="/">
              <HomeOutlined style={{ marginRight: 4 }} /> Inicio
            </Nav.Link>
            <Nav.Link href="/pacientes" eventKey="/pacientes">
              <UserOutlined style={{ marginRight: 4 }} /> Pacientes
            </Nav.Link>
            <Nav.Link href="/citas" eventKey="/citas">
              <CalendarOutlined style={{ marginRight: 4 }} /> Citas
            </Nav.Link>
            <NavDropdown
              title={<><TeamOutlined style={{ marginRight: 4 }} /> Personal</>}
              id="personal-dropdown"
              active={STAFF_PATHS.includes(pathname)}
            >
              <NavDropdown.Item href="/doctores">Médicos</NavDropdown.Item>
              <NavDropdown.Item href="/recepcionistas">Recepcionistas</NavDropdown.Item>
              <NavDropdown.Item href="/enfermeros">Enfermeros</NavDropdown.Item>
            </NavDropdown>
            <NavDropdown
              title={<><DollarCircleOutlined style={{ marginRight: 4 }} /> Finanzas</>}
              id="finanzas-dropdown"
              active={FINANCE_PATHS.includes(pathname)}
            >
              <NavDropdown.Item href="/balances">Balances</NavDropdown.Item>
              <NavDropdown.Item href="/cortes">Cortes</NavDropdown.Item>
            </NavDropdown>
          </Nav>
          <Nav>
            <NavDropdown
              title={<><UserOutlined style={{ marginRight: 6 }} />{usuario.name.split(' ')[0]}</>}
              id="user-dropdown"
              align="end"
            >
              <NavDropdown.Item href="/perfil">Mi perfil</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item onClick={logout} style={{ color: '#dc3545' }}>
                <LogoutOutlined style={{ marginRight: 6 }} /> Cerrar sesión
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default function AdminHospitalApp() {
  return (
    <Router>
      <Navigator />
      <Switch>
        <Route path="/sucursal">
          <Sucursal />
        </Route>
        <Route path="/recepcionistas">
          <Receptionists />
        </Route>
        <Route path="/enfermeros">
          <Enfermeros />
        </Route>
        <Route path="/doctores">
          <Doctors />
        </Route>
        <Route path="/citas">
          <Citas />
        </Route>
        <Route path="/pacientes">
          <Dash />
        </Route>
        <Route path="/escalas">
          <Escalas />
        </Route>
        <Route path="/balances">
          <Ingresos />
        </Route>
        <Route path="/cortes">
          <Cortes />
        </Route>
        <Route path="/escalas-emt">
          <EscalasEMT />
        </Route>
        <Route path="/hoja-registro-emt">
          <HojaRegistroEMT />
        </Route>
        <Route path="/perfil">
          <PerfilAdministrador />
        </Route>
        <Route path="/">
          <Home />
        </Route>
      </Switch>
      <Footer />
    </Router>
  )
}
